import { render, staticRenderFns } from "./CustomerDocument.vue?vue&type=template&id=162ccac0"
import script from "./CustomerDocument.vue?vue&type=script&lang=js"
export * from "./CustomerDocument.vue?vue&type=script&lang=js"
import style0 from "./CustomerDocument.vue?vue&type=style&index=0&id=162ccac0&prod&lang=css"
import style1 from "./CustomerDocument.vue?vue&type=style&index=1&id=162ccac0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports